import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix missing marker icons (optional)
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const GpsTracker: React.FC = () => {
    const [coords, setCoords] = useState<{ lat: number; lng: number } | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [showMap, setShowMap] = useState<boolean>(false);
    const [address, setAddress] = useState<string | null>(null);

    useEffect(() => {
        if (!navigator.geolocation) {
            setError("Geolocation is not supported by your browser.");
            return;
        }

        const watchId = navigator.geolocation.watchPosition(
            (position) => {
                const newCoords = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                setCoords(newCoords);

                // Fetch full address from Nominatim (OpenStreetMap)
                fetch(`https://nominatim.openstreetmap.org/reverse?lat=${newCoords.lat}&lon=${newCoords.lng}&format=json`)
                    .then(res => res.json())
                    .then(data => {
                        if (data && data.display_name) {
                            setAddress(data.display_name);
                        }
                    })
                    .catch(() => setAddress('Unable to fetch address'));
            },
            (err) => {
                setError(err.message);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );

        return () => navigator.geolocation.clearWatch(watchId);
    }, []);



    return (
        <div className='w-full h-screen flex flex-row justify-center item-center gps-tracker-container p-4 bg-white'>
        <div className='w-full  flex flex-col justify-center items-center p-4 bg-white shadow-md rounded-lg border  border-1 border-green-200'>
            <h2 className='text-xl font-bold mb-2'>GPS Tracker</h2>
            {error && <p className='text-red-500'>Error: {error}</p>}

            {coords ? (
                <>
                    <p className='flex flex-col'>
                        <span>Latitude: {coords.lat}</span>
                        <span>Longitude: {coords.lng}</span>
                        </p>
                    <button
                        onClick={() => setShowMap(true)}
                        className='mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700'
                    >
                        Show Map
                    </button>
                </>
            ) : (
                <p>Locating...</p>
            )}

            {address && (
                <div className="mt-2 text-lg text-gray-600 flex flex-col items-center">
                    <p>📍 <strong>Address:</strong></p>
                    <p>{address}</p> 
                </div>
            )}

            {/* Modal */}
            {showMap && coords && (
                <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
                    <div className='bg-white rounded-lg shadow-lg p-4 w-full  relative'>
                        <button
                            onClick={() => setShowMap(false)}
                            className='absolute top-2 right-2 text-gray-600 hover:text-red-600'
                        >
                            ×
                        </button>

                        <MapContainer
                            center={[coords.lat, coords.lng]}
                            zoom={16}
                            scrollWheelZoom={true}
                            style={{ height: '500px', width: '100%' }}
                        >
                            <TileLayer
                                attribution='&copy; OpenStreetMap contributors'
                                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                            />
                            <Marker position={[coords.lat, coords.lng]}>
                                <Popup>Your current location</Popup>
                            </Marker>
                        </MapContainer>
                    </div>
                </div>
            )}
        </div>
        </div>
    );
};

export default GpsTracker;
